import { Navigate, Route, RouteProps, Routes } from "react-router-dom";
import { OffresView } from "./screens/app/catalogue";
import { PassRailDescriptionView } from "./screens/app/catalogue/description/PassRail";
import { CarteJeuneDescriptionView } from "./screens/app/catalogue/description/CarteAdvantageJeune";
import { CarteAvantageAdulteView } from "./screens/app/catalogue/description/CarteAdvantageAdulte";
import { CarteAvantageSeniorView } from "./screens/app/catalogue/description/CarteAdvantageSenior";
import { CarteLiberteView } from "./screens/app/catalogue/description/CarteLiberte";
import { Informations } from "./screens/app/catalogue/pricing/sncf-step3";
import { CartView } from "./screens/app/cart";
import { PaiementView } from "./screens/app/paiement";
import { PriceIds } from "./lib/utils";
import { Merci } from "./screens/app/merci";
import { BasePricingView } from "./screens/app/catalogue/pricing/etape-1";

export const RouteManager = () => {
  const routesConfig: RouteProps[] = [
    { path: "/app/catalogue", element: <OffresView /> },
    {
      path: "/app/catalogue/description/pass-rail",
      element: <PassRailDescriptionView />,
    },
    {
      path: "/app/catalogue/description/carte-avantage-jeune",
      element: <CarteJeuneDescriptionView />,
    },
    {
      path: "/app/catalogue/description/carte-avantage-adulte",
      element: <CarteAvantageAdulteView />,
    },
    {
      path: "/app/catalogue/description/carte-avantage-senior",
      element: <CarteAvantageSeniorView />,
    },
    {
      path: "/app/catalogue/description/carte-liberte",
      element: <CarteLiberteView />,
    },
    {
      path: "/app/catalogue/pricing/sncf-step3",
      element: <Informations />,
    },
    {
      path: "/app/cart",
      element: <CartView />,
    },
    {
      path: "/app/paiement",
      element: <PaiementView />,
    },
    {
      path: "/app/merci",
      element: <Merci />,
    },
  ];

  const pricingRoutes: RouteProps[] = [
    {
      path: `/app/catalogue/pricing/sncf`,
      element: <BasePricingView />,
    },
  ];

  const routes = () => (
    <>
      {routesConfig.map(({ path, element }, index) => (
        <Route key={index} path={path} element={element} />
      ))}
      {pricingRoutes.map(({ path, element }, index) => (
        <Route key={index} path={path} element={element} />
      ))}
      <Route path="*" element={<Navigate to="/app/catalogue" replace />} />
    </>
  );

  return <Routes>{routes()}</Routes>;
};
